module.exports = __webpack_public_path__ + "assets/img/seckill.0804d524.png";